module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.photosets), function(set) {
    return _c('div', {
      staticClass: "col-md-4",
      on: {
        "click": function($event) {
          _vm.goToPhotoset(set.id)
        }
      }
    }, [_c('photoset-intro', {
      attrs: {
        "details": set
      }
    })], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-733699d9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/routes/Home.vue
// module id = 125
// module chunks = 2